// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QfBVCFLfAEcJOXmz {
  padding-top: 69px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 600px;
  margin: 0 auto;
  padding-bottom: 96px;
}

.QfBVCFLfAEcJOXmz img {
  width: 96px;
  margin-bottom: 35px;
}

.QfBVCFLfAEcJOXmz h1 {
  margin: 0;
  font-family: Roboto;
  font-weight: normal;
  font-size: 40px;
  margin-bottom: 60px;
}

.QfBVCFLfAEcJOXmz p {
  font-family: Roboto;
  font-weight: 200;
  text-align: center;
  line-height: 140%;
  margin: 0;
  margin-bottom: 26px;
}

.rWRvufREIYIoOLTw {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 70px;
  width: 100%;
}

.rWRvufREIYIoOLTw p {
  font-weight: normal;
  font-size: 20px;
  margin: 0;
  margin-bottom: 20px;
}

.rWRvufREIYIoOLTw a {
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #20336c;
  padding: 18px;
  font-size: 20px;
  border-radius: 16px;
  font-weight: 700;
  color: #ffffff;
}

@media screen and (max-width: 1280px) {
  .QfBVCFLfAEcJOXmz {
    padding-bottom: 64px;
  }
}

@media screen and (max-width: 1024px) {
  .QfBVCFLfAEcJOXmz {
    padding-bottom: 108px;
  }
}

@media screen and (max-width: 768px) {
  .QfBVCFLfAEcJOXmz {
    padding-top: 26px;
    width: 306px;
    margin: 0 auto;
  }

  .QfBVCFLfAEcJOXmz img {
    margin-bottom: 32px;
  }

  .QfBVCFLfAEcJOXmz h1 {
    font-size: 20px;
    margin-bottom: 40px;
    text-align: left;
    width: 100%;
  }

  .QfBVCFLfAEcJOXmz p {
    text-align: left;
    margin-bottom: 32px;
  }

  .rWRvufREIYIoOLTw {
    margin-top: 30px;
    width: 100%;
  }

  .rWRvufREIYIoOLTw p {
    font-size: 16px;
    margin-bottom: 22px;
    text-align: center;
  }

  .rWRvufREIYIoOLTw a {
    padding: 13px;
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Root.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;AACF","sourcesContent":[".wrapper {\r\n  padding-top: 69px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  width: 600px;\r\n  margin: 0 auto;\r\n  padding-bottom: 96px;\r\n}\r\n\r\n.wrapper img {\r\n  width: 96px;\r\n  margin-bottom: 35px;\r\n}\r\n\r\n.wrapper h1 {\r\n  margin: 0;\r\n  font-family: Roboto;\r\n  font-weight: normal;\r\n  font-size: 40px;\r\n  margin-bottom: 60px;\r\n}\r\n\r\n.wrapper p {\r\n  font-family: Roboto;\r\n  font-weight: 200;\r\n  text-align: center;\r\n  line-height: 140%;\r\n  margin: 0;\r\n  margin-bottom: 26px;\r\n}\r\n\r\n.CTAWrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  margin-top: 70px;\r\n  width: 100%;\r\n}\r\n\r\n.CTAWrapper p {\r\n  font-weight: normal;\r\n  font-size: 20px;\r\n  margin: 0;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.CTAWrapper a {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  background-color: #20336c;\r\n  padding: 18px;\r\n  font-size: 20px;\r\n  border-radius: 16px;\r\n  font-weight: 700;\r\n  color: #ffffff;\r\n}\r\n\r\n@media screen and (max-width: 1280px) {\r\n  .wrapper {\r\n    padding-bottom: 64px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1024px) {\r\n  .wrapper {\r\n    padding-bottom: 108px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .wrapper {\r\n    padding-top: 26px;\r\n    width: 306px;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  .wrapper img {\r\n    margin-bottom: 32px;\r\n  }\r\n\r\n  .wrapper h1 {\r\n    font-size: 20px;\r\n    margin-bottom: 40px;\r\n    text-align: left;\r\n    width: 100%;\r\n  }\r\n\r\n  .wrapper p {\r\n    text-align: left;\r\n    margin-bottom: 32px;\r\n  }\r\n\r\n  .CTAWrapper {\r\n    margin-top: 30px;\r\n    width: 100%;\r\n  }\r\n\r\n  .CTAWrapper p {\r\n    font-size: 16px;\r\n    margin-bottom: 22px;\r\n    text-align: center;\r\n  }\r\n\r\n  .CTAWrapper a {\r\n    padding: 13px;\r\n    font-size: 14px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var wrapper = `QfBVCFLfAEcJOXmz`;
export var CTAWrapper = `rWRvufREIYIoOLTw`;
export default ___CSS_LOADER_EXPORT___;
